module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$route.path === '/resources-and-tools/ogden-table-viewer') ? _c('div', {
    staticClass: "flex-grid p-resources-and-tools__documents"
  }, [_c('h2', [_vm._v("Ogden Table Viewer")]), _vm._v(" "), _c('div', {
    staticClass: "p-resources-and-tools__document"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedTable),
      expression: "selectedTable"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedTable = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.obtainOgdenTable()
      }]
    }
  }, _vm._l((_vm.ogdenTables), function(ogdenTable) {
    return _c('option', {
      domProps: {
        "value": ogdenTable
      }
    }, [_vm._v(_vm._s(ogdenTable.name) + " -\n                    " + _vm._s(ogdenTable.description) + "\n                ")])
  }), 0)]), _vm._v(" "), (!!_vm.tableData && _vm.selectedTable) ? _c('ogden-table-viewer', {
    attrs: {
      "description": _vm.selectedTable.description,
      "name": _vm.selectedTable.name,
      "tableData": _vm.tableData
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.$route.path === '/resources-and-tools/at-a-glance-viewer') ? _c('div', {
    staticClass: "flex-grid p-resources-and-tools__documents",
    on: {
      "change": function($event) {
        return _vm.atAGlanceViewer()
      }
    }
  }, [_c('h2', [_vm._v("At a Glance Viewer")]), _vm._v(" "), _c('div', {
    staticClass: "p-resources-and-tools__document"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gender),
      expression: "gender"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.gender = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "male"
    }
  }, [_vm._v("Male")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "female"
    }
  }, [_vm._v("Female")])]), _vm._v("\n            Discount\n            "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.discount),
      expression: "discount"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.discount = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.discounts), function(discount) {
    return _c('option', {
      domProps: {
        "value": discount
      }
    }, [_vm._v(_vm._s(discount) + "%")])
  }), 0)]), _vm._v(" "), (_vm.atAGlance.data) ? _c('at-a-glance-viewer', {
    attrs: {
      "description": _vm.gender + ' - ' + _vm.discount + '%',
      "name": 'At A Glance Ogden Viewer',
      "tableData": _vm.atAGlance.data
    }
  }) : _vm._e()], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-aa0d1b06!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/resources-and-tools/OgdenTable.vue
// module id = 1788
// module chunks = 0